{
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }

  const item_list_id = sessionStorage.getItem('item_list_id') || '';
  const item_list_name = sessionStorage.getItem('item_list_name') || '';
  const page_location = window.location.href;
  const page_referrer = document.referrer;
  const page_title = document.title;
  const currency = 'GBP';

  function init() {
    ga4_menu_data();
    ga4_scroll_data();
    ga4_bottom_menu_data();
    setTimeout(() => {
      ga4_mini_cart_data();
    }, 1000);
    setTimeout(() => {
      ga4_float();
    }, 2000);
  }
  function ga4_home_init() {
    // ga4_home_video_click();
    ga4_home_block_click();
  }
  function ga4_other_page_init() {
    const path_obj = {
      '/pages/': [{ fn: ga4_page_data }],
      '/pages/compare': [{ fn: ga4_compare_page_data }],
      '/pages/service': [{ fn: ga4_service_page_data }],
      '/pages/compatibility': [{ fn: ga4_compatibility_page_data }],
      '/pages/solution-software': [{ fn: ga4_solution_software_page_data }],
      '/pages/what-is-nas': [{ fn: ga4_what_is_nas_page_data }],
      '/pages/nas-selector': [{ fn: ga4_nas_selector_page_data, delay: 500 }],
      '/pages/raid-calculator': [{ fn: ga4_raid_calculator_page_data }],
      '/pages/operating-system': [
        { fn: ga4_operating_system_page_data, delay: 500 },
      ],
      '/pages/solutIons-for-home': [
        { fn: ga4_solutions_for_home_page_data, delay: 500 },
      ],
      '/pages/explore': [{ fn: ga4_explore_page_data, delay: 500 }],
      '/pages/video-center': [{ fn: ga4_video_center_page_data, delay: 500 }],
      '/pages/media-center': [{ fn: ga4_media_center_page_data, delay: 500 }],
      '/pages/blogs': [{ fn: ga4_blogs_page_data, delay: 500 }],
      '/pages/app-download': [{ fn: ga4_app_download_page_data, delay: 500 }],
      '/pages/policy': [{ fn: ga4_policy_page_data, delay: 500 }],
    };
    const path = window.UGrequest.path;

    if (path_obj[path]) {
      path_obj[path].forEach((item) => {
        if (typeof item.fn === 'function') {
          setTimeout(() => {
            item.fn();
          }, item.delay || 0);
        }
      });
    }
    // 通用函数执行
    path_obj['/pages/'].forEach((item) => {
      if (typeof item.fn === 'function') {
        setTimeout(() => {
          item.fn();
        }, item.delay || 0);
      }
    });
  }
  function ga4_collection_init() {
    ga4_collection_data();
  }
  function ga4_product_init() {
    ga4_product_detail_data();
    ga4_product_variant_data();
    ga4_product_info_area_data();
    ga4_product_a_plus_data();
    ga4_product_faq_data();
    ga4_product_add_to_cart_data();
  }

  function ga4_blogs_init() {
    setTimeout(() => {
      ga4_article_data();
    }, 1000);
  }

  /************************ 全局 **************************/
  // 导航各按钮【全局】
  function ga4_menu_data() {
    const dataList = [
      // pc 端菜单栏
      {
        wrapper_dom: 'sticky-header details',
        dom: 'summary',
        event_name: 'top_navigation',
        children: [
          {
            dom: 'sticky-header details .mega-menu__content a',
            event_name: 'top_navigation',
            except_dom: [
              'a.mega-menu__item--product',
              'a.mega-menu__item--collection',
            ], // 排除二级菜单中的产品链接和登录按钮
            log_name: '菜单导航按钮点击【二级】',
          },
        ],
        except_dom: ['.header__icon--menu'],
        log_name: '菜单导航按钮点击【一级】',
      },
      {
        wrapper_dom: 'sticky-header header',
        dom: 'a.header__heading-link',
        event_name: 'top_navigation',
        navigation: {
          level: '1',
          name: 'Logo',
        },
        log_name: '菜单导行 Logo 点击',
      },
      {
        wrapper_dom: 'sticky-header header .icons-wrapper',
        dom: 'a.login_btn',
        event_name: 'top_navigation',
        navigation: {
          level: '1',
          name: 'Login Button',
        },
        log_name: '菜单导航按钮点击【Login Button】',
      },
      {
        wrapper_dom: 'sticky-header header .icons-wrapper',
        dom: 'button.header__icon--cart',
        event_name: 'top_navigation',
        navigation: {
          level: '1',
          name: 'Cart Button',
        },
        log_name: ' 菜单导航按钮点击【Cart Button】',
      },
      {
        wrapper_dom: '.ug-brand-bar',
        dom: '.ug-brand-bar__logo',
        event_name: 'top_navigation',
        navigation: {
          level: '1',
          name: 'Brand Info Logo',
        },
        log_name: '品牌栏按钮点击【品牌信息 logo】',
      },
      {
        wrapper_dom: '.utility-bar',
        dom: '.announcement-bar a',
        event_name: 'top_navigation',
        navigation: {
          level: '1',
          name: 'Announcement Bar',
        },
        log_name: 'Top Bar 按钮点击【公告栏】',
      },
      // 移动端菜单栏
      {
        wrapper_dom: 'sticky-header header-drawer',
        dom: '.header__icon--menu',
        event_name: 'top_navigation',
        navigation: {
          level: '1',
          name: 'Mobile Menu Drawer',
        },
        log_name: '移动端打开菜单栏',
      },
      {
        wrapper_dom: '#menu-drawer ul.menu-drawer__menu > li',
        dom: '.menu-drawer__menu-item',
        event_name: 'top_navigation',
        children: [
          {
            dom: '.sub-menu a',
            event_name: 'top_navigation',
            except_dom: [
              '.mb-mega-menu__item--product',
              '.mb-mega-menu__item--collection',
            ], // 排除二级菜单中的产品链接和登录按钮
            log_name: '移动端菜单导航按钮点击【二级】',
          },
        ],
        log_name: '移动端菜单导航按钮点击【一级】',
      },
    ];
    navigation_listen_click(dataList);

    const other_data = [
      {
        wrapper_dom: '.ug-brand-bar',
        dom: '.ug-change-countrylanFn',
        event_name: 'country_select',
        log_name: '切换国家按钮点击',
        position: 'wrapper',
        module: 'Top module',
      },
      {
        wrapper_dom: '.ug-brand-bar',
        dom: '.ug-brand_bar-countrylan-select a',
        module: 'Top module',
        event_name: 'country_select',
        log_name: '选择国家',
        position: 'inner',
      },
      {
        wrapper_dom: '.footer__content-bottom-wrapper',
        dom: '.footer-ugchangeLanguagediv',
        event_name: 'country_select',
        log_name: '底部切换国家按钮点击',
        module: 'Bottom module',
        position: 'wrapper',
      },
      {
        wrapper_dom: '.footer__content-bottom-wrapper',
        dom: '.ug-change-countrylan a',
        event_name: 'country_select',
        log_name: '底部选择国家',
        module: 'Bottom module',
        position: 'inner',
      },
      {
        wrapper_dom: 'sticky-header .ug-menu-list-item',
        dom: 'a.mega-menu__item--collection',
        event_name: 'click_button',
        button_name: 'View Collection',
        log_name: '顶部导航查看专辑',
        module: 'Top module',
      },
      // 移动端
      {
        wrapper_dom: '#menu-drawer ul.menu-drawer__menu > li',
        dom: 'a.mb-mega-menu__item--collection',
        event_name: 'click_button',
        button_name: 'View Collection',
        log_name: '顶部导航查看专辑 【移动端】',
        module: 'Top module',
      },
    ];
    dom_listen_click(other_data);
  }

  // 底部导航按钮【全局】
  function ga4_bottom_menu_data() {
    const dataList = [
      {
        wrapper_dom: '.footer__content-top .footer__blocks-wrapper',
        dom: '.footer-block a',
        event_name: 'bottom_navigation',
        log_name: '底部导航按钮点击',
      },
      {
        wrapper_dom: '.footer__content-top .footer__blocks-wrapper',
        dom: 'h3#ug-technicalSupport',
        event_name: 'bottom_navigation',
        log_name: '底部技术支持按钮点击',
      },
      {
        wrapper_dom: '.footer__content-top .footer__blocks-wrapper',
        dom: 'h3#ug-liveChatFn',
        event_name: 'bottom_navigation',
        log_name: '底部客户服务按钮点击',
      },
      {
        wrapper_dom: '.footer__content-bottom',
        dom: '.footer__copyright_link',
        event_name: 'bottom_navigation',
        log_name: '底部版权链接点击',
      },
      {
        wrapper_dom: '.footer__content-bottom',
        dom: '.truste-logo_link',
        event_name: 'bottom_navigation',
        log_name: 'truste logo 点击',
      },
    ];
    navigation_listen_click(dataList);
    // 社媒按钮
    const social_btn_items =
      document.querySelectorAll('.ug-footer-socialsdiv a.socials-icon-wrap') ||
      [];
    social_btn_items.forEach(function (item) {
      item?.addEventListener('click', function (event) {
        const button_name = [
          'tiktok',
          'instagram',
          'facebook',
          'twitter',
          'youtube',
        ].find((name) => item.href.includes(name));

        Shopify.analytics.publish('ga4Event', {
          log_name: '社媒按钮' + button_name,
          event_name: 'bottom_function',
          event_parameters: {
            button_name,
            position: 'Bottom nav',
          },
        });
      });
    });
  }

  // 悬浮功能按钮 【全局】
  function ga4_float() {
    // 监听 zendesk 打开消息框 【 https://developer.zendesk.com/api-reference/widget-messaging/web/core/ 】
    if(typeof zE === 'undefined') return;
    zE('messenger:on', 'open', () => {
      Shopify.analytics.publish('ga4Event', {
        log_name: '悬浮功能按钮点击【Live Chat】',
        event_name: 'float_bar',
        event_parameters: {
          button_name: 'Live Chat',
        },
      });
    });
  }

  /************************ 主页模块 **************************/
  function ga4_home_video_click() {
    const video_items_wrap = document.querySelectorAll(
      '.ug-index-hot-videos .swiper-slide'
    );
    video_items_wrap.forEach(function (item, index) {
      const video_item_play_btn = item.querySelector(
        '.deferred-media__poster-button'
      );
      const title = item.querySelector(
        'h2.ug-hot-videos-swiper-conth2'
      )?.innerText;
      video_item_play_btn?.addEventListener('click', function (event) {
        Shopify.analytics.publish('ga4Event', {
          log_name: '主页热门视频点击',
          event_name: 'video_start',
          event_parameters: {
            video_title: title,
            position: 'Home Hot Videos',
            index: index,
          },
        });
      });
    });

    const video_items_wrap_remake = document.querySelectorAll('.ug-full-video');
    video_items_wrap_remake.forEach(function (item, index) {
      const video_item_play_btn = item.querySelector('.ug-full-video-btn');
      const title = item.querySelector('.ug-full-video-conth1')?.innerText;

      video_item_play_btn?.addEventListener('click', function (event) {
        Shopify.analytics.publish('ga4Event', {
          log_name: '主页全屏视频点击',
          event_name: 'video_start',
          event_parameters: {
            video_title: title,
            position: 'Home Full Video',
            index: index,
          },
        });
      });
    });
  }

  function ga4_home_block_click() {
    const dataList = [
      {
        wrapper_dom: '.ug-index-recommended .ug-index-recommended__item',
        dom: 'a.ug-btn',
        text_dom: '.ug-index-recommended__item__content > h3',
        event_name: 'click_button',
        log_name: '主页 NASync Series 模块',
        module: 'Home NASync Series',
      },
      {
        wrapper_dom: '.ug-index-banner-center-div',
        dom: '.ug-index-benner-cont a',
        text_dom: '.ug-index-benner-cont h2',
        event_name: 'click_button',
        log_name: '主页 Banner Center 模块',
        module: 'Home Banner Center',
      },
      {
        wrapper_dom: '.ug-index-solutions-grid .item',
        dom: 'a.item-link',
        text_dom: '.wrapper h4',
        event_name: 'click_button',
        log_name: '主页 Solutions 模块',
        module: 'Home Solutions Grid',
      },
      {
        wrapper_dom: 'ug-card-slider .item',
        dom: '.item-link',
        text_dom: '.item-title',
        event_name: 'click_button',
        log_name: '主页 About NAS Blogs 模块',
        module: 'Home About NAS Blogs',
      },
      {
        wrapper_dom: 'ug-card-slider .item',
        dom: '.view-all',
        event_name: 'click_button',
        button_name: 'View All',
        log_name: '主页 About NAS Blogs 模块 View All',
        module: 'Home About NAS Blogs',
      },
      {
        wrapper_dom: '.ug-index-service .item',
        dom: 'a.item-link',
        text_dom: '.wrapper h4',
        event_name: 'click_button',
        log_name: '主页 Quick Service 模块',
        module: 'Home Quick Service',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/通用函数 **************************/
  function ga4_page_data() {
    const dataList = [
      {
        dom: '.ug-suppor-learnmore a',
        text_dom: '.ug-support-learn-cont h3',
        event_name: 'click_button',
        log_name: ' Learn More 按钮点击',
        module: 'Learn More',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/compare **************************/
  function ga4_compare_page_data() {
    safeAddEventListeners({
      selector: '.ug-product-compare-selectdiv .ug-product-compare-select',
      callback: (items) => {
        items?.forEach(function (item, index) {
          item?.addEventListener('change', function (event) {
            const button_name =
              event.target?.selectedOptions[0]?.text ?? `select_item_${index}`;
            const product_name = Array.from(
              document.querySelectorAll(
                '.ug-product-compare-selectdiv .ug-product-compare-select-item'
              )
            )
              .map((item) => item.selectedOptions[0].text)
              .join(',');
            Shopify.analytics.publish('ga4Event', {
              log_name: '产品对比表头点击',
              event_name: 'compare_products',
              event_parameters: {
                product_name,
                button_name,
                index,
              },
            });
          });
        });
      },
    });

    safeAddEventListeners({
      selector: '.ug-product-compare-modeldiv',
      callback: (items) => {
        items?.forEach(function (item) {
          item?.addEventListener('click', function (event) {
            const button_name = item.querySelector(
              '.ug-product-compare-modeldivnr h3'
            )?.innerText;
            Shopify.analytics.publish('ga4Event', {
              log_name: '产品对比展开详情',
              event_name: 'click_button',
              event_parameters: {
                module: 'Compare NAS Models',
                button_name,
              },
            });
          });
        });
      },
    });

    safeAddEventListeners({
      selector: '#ug-product-compare-switch-val',
      callback: (items) => {
        items.forEach(function (item) {
          item?.addEventListener('click', function (event) {
            const button_name = 'Show Different';
            Shopify.analytics.publish('ga4Event', {
              log_name: '产品对比不同参数',
              event_name: 'click_button',
              event_parameters: {
                module: 'Compare NAS Models',
                button_name,
              },
            });
          });
        });
      },
    });
  }

  /************************ /pages/service **************************/
  function ga4_service_page_data() {
    const dataList = [
      {
        wrapper_dom: '.ug-icons-bar .items',
        dom: '.ug-column-link',
        text_dom: '.ug-column-title',
        event_name: 'click_button',
        log_name: '服务页面图标点击',
        module: 'Help Center Icons Bar',
      },
      {
        wrapper_dom: 'ug-grid-card .item',
        dom: 'a.item-link',
        text_dom: 'h4.item-title',
        event_name: 'click_button',
        log_name: '服务页面 Grid Card 点击',
        module: 'Help Center Grid Card',
      },
      {
        wrapper_dom: 'ug-contact-us',
        dom: 'a',
        event_name: 'click_button',
        log_name: '服务页面 联系我们 点击',
        module: 'Help Center Contact Us',
      },
      {
        wrapper_dom: 'ug-faq-accordion',
        dom: '.ac-header button.ac-trigger',
        event_name: 'click_button',
        log_name: '服务页面 FAQ 点击',
        module: 'Help Center FAQ',
      },
      {
        wrapper_dom: 'ug-faq-accordion .section-link',
        dom: 'a',
        event_name: 'click_button',
        button_name: 'More FAQ',
        log_name: '服务页面 More FAQ 点击',
        module: 'Help Center FAQ',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/compatibility **************************/
  function ga4_compatibility_page_data() {
    const dataList = [
      {
        dom: '.ug-products-compatibility-tablediv .ug-product-compatibility-tab-item',
        text_dom: '.product-compatibility-pointerEvents-itemin h3',
        event_name: 'select_content_category',
        log_name: '兼容性页面 产品兼容性 点击',
        module: 'Compatibility',
        event_parameters: {
          content_type: 'Compatibility List',
        },
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/solution-software **************************/
  function ga4_solution_software_page_data() {
    const dataList = [
      {
        dom: '.introduction-pagination-ul .introduction-pagination-itemin',
        event_name: 'click_button',
        log_name: '解决方案软件页面 banner icons 点击',
        module: 'Solution Software Banner Icons',
      },
      {
        dom: '.introduction-icon-list .introduction-icon-item',
        event_name: 'click_button',
        log_name: '解决方案软件页面 中间 icons 点击',
        module: 'Solution Software Middle Icons',
      },
      {
        dom: '.introduction-cont-item .introduction-cont-item-l .introduction-cont-item-titlediv .introduction-cont-item-title',
        event_name: 'click_button',
        log_name: '解决方案软件页面 内容按钮点击',
        module: 'Solution Software Content',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/what-is-nas **************************/
  function ga4_what_is_nas_page_data() {
    const dataList = [
      {
        dom: 'ug-btn a',
        event_name: 'click_button',
        log_name: 'What is NAS 页面 Better for you 按钮点击',
        module: 'What is NAS',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/nas-selector **************************/
  function ga4_nas_selector_page_data() {
    const dataList = [
      {
        dom: '#section-first .option-box .option',
        text_dom: '.option-title',
        event_name: 'click_button',
        log_name: 'NAS 帮助选择页面 section 1 点击',
        module: 'NAS Selector',
      },
      {
        dom: '#section-first .reset-btn',
        event_name: 'click_button',
        button_name: 'Reset',
        log_name: 'NAS 帮助选择页面 section 1 重置按钮点击',
        module: 'NAS Selector',
      },
      {
        dom: '#section-second .option-box .option',
        event_name: 'click_button',
        text_dom: '.option-title',
        log_name: 'NAS 帮助选择页面 section 2 应用按钮点击',
        module: 'NAS Selector',
      },
      {
        dom: '#section-second .reset-btn',
        event_name: 'click_button',
        button_name: 'Reset',
        log_name: 'NAS 帮助选择页面 section 2 重置按钮点击',
        module: 'NAS Selector',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/raid-calculator **************************/
  function ga4_raid_calculator_page_data() {
    const dataList = [
      {
        dom: '.drives-wrapper .type-wrapper .type',
        event_name: 'click_button',
        log_name: 'RAID 计算器页面 驱动类型点击',
        module: 'RAID Calculator',
      },
      {
        dom: '.drives-wrapper .drives .drive',
        event_name: 'click_button',
        log_name: 'RAID 计算器页面 盘位容量点击',
        module: 'RAID Calculator',
      },
      {
        dom: '.drives-wrapper .bottom-wrapper .bottom .block',
        event_name: 'click_button',
        button_name: 'Cancel',
        log_name: 'RAID 计算器页面 取消磁盘阵列类型点击',
        module: 'RAID Calculator',
      },
      {
        dom: '.drives-wrapper .bottom-wrapper #reset',
        event_name: 'click_button',
        button_name: 'Reset',
        log_name: 'RAID 计算器页面 重置按钮点击',
        module: 'RAID Calculator',
      },
      {
        dom: 'a.recommended-btn',
        event_name: 'click_button',
        log_name: 'RAID 计算器页面 推荐方案按钮点击',
        module: 'RAID Calculator',
      },
    ];
    dom_listen_click(dataList);
    const select_items = document.querySelectorAll(
      '.progressBar .result-box select.select-box'
    );
    select_items.forEach(function (item) {
      item?.addEventListener('change', function (event) {
        const button_name = item.selectedOptions[0].text;
        Shopify.analytics.publish('ga4Event', {
          log_name: 'RAID 计算器页面 磁盘阵列类型选择',
          event_name: 'click_button',
          event_parameters: {
            module: 'RAID Calculator',
            button_name,
          },
        });
      });
    });
  }
  /************************ /pages/operating-system **************************/
  function ga4_operating_system_page_data() {
    const dataList = [
      {
        dom: '.ugos-section6 .ugos-div6-control-item',
        event_name: 'click_button',
        log_name: '操作系统页面 产品卡片点击',
        module: 'Operating System',
      },
      {
        dom: '.ugos-div7-divinsudiv a',
        event_name: 'click_button',
        log_name: '操作系统页面 跳转 app center',
        module: 'Operating System',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/solutions-for-home **************************/
  function ga4_solutions_for_home_page_data() {
    const dataList = [
      {
        wrapper_dom: 'ug-solutions-slider .swiper-slide',
        dom: 'a',
        text_dom: '.info',
        event_name: 'click_button',
        log_name: '解决方案页面卡片点击',
        module: 'Solutions for Home',
      },
      {
        dom: 'ug-solutions-slider .btn-control .ay-prev',
        event_name: 'click_button',
        button_name: 'Previous',
        log_name: '解决方案页面 左箭头点击',
        module: 'Solutions for Home',
      },
      {
        dom: 'ug-solutions-slider .btn-control .ay-next',
        event_name: 'click_button',
        button_name: 'Next',
        log_name: '解决方案页面 右箭头点击',
        module: 'Solutions for Home',
      },
      {
        dom: '.ug-compare-viewAll .ug-compare-btn',
        event_name: 'click_button',
        button_name: 'Compare All',
        log_name: '解决方案页面 查看对比按钮点击',
        module: 'Solutions for Home',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/explore **************************/
  function ga4_explore_page_data() {
    const dataList = [
      {
        wrapper_dom: 'ug-explore-main-tips .content .item',
        dom: '.item-link',
        text_dom: '.item-title',
        event_name: 'click_button',
        log_name: '探索页面 Feature Tips',
        module: 'Feature Tips',
      },
      {
        dom: 'ug-explore-main-tips .view-all',
        event_name: 'click_button',
        button_name: 'See All Tips ',
        log_name: '探索页面 查看所有按钮点击',
        module: 'Feature Tips',
      },
      {
        wrapper_dom: 'ug-grid-card .ug-container .box .item',
        dom: 'a.item-link',
        text_dom: 'h4.item-title',
        event_name: 'click_button',
        log_name: '探索页面 Facebook 卡片点击',
        module: 'Facebook Card',
      },
      {
        wrapper_dom: 'ug-explore-main-big-pic .content .item',
        dom: '.item-link',
        text_dom: '.item-title',
        event_name: 'click_button',
        log_name: '探索页面 Solutions 卡片点击',
        module: 'Solutions',
      },
      {
        wrapper_dom: 'ug-explore-main-video .content-video .item',
        dom: '.play-button',
        text_dom: '.item-title',
        event_name: 'click_button',
        log_name: '探索页面 Video play btn 点击',
        module: 'Video Card',
      },
      {
        dom: 'ug-explore-main-video .content-video .item .item-link a',
        event_name: 'click_button',
        button_name: 'Go to Video Center',
        log_name: '探索页面 Video view all 按钮点击',
        module: 'Video Card',
      },
      {
        wrapper_dom: 'ug-explore-main-video .content-article .item',
        dom: 'a',
        text_dom: '.item-title',
        event_name: 'click_button',
        log_name: '探索页面 Video 卡片点击',
        module: 'Video Card',
      },
      {
        wrapper_dom: 'ug-card-slider .content .item',
        dom: '.item-link a',
        text_dom: '.item-title',
        event_name: 'click_button',
        log_name: '探索页面 Knowledge Center 产品卡片点击',
        module: 'Knowledge Center',
      },
      {
        dom: 'ug-card-slider .ug-btn a',
        event_name: 'click_button',
        button_name: 'View All',
        log_name: '探索页面 Knowledge Center 查看所有按钮点击',
        module: 'Knowledge Center',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/video-center **************************/
  function ga4_video_center_page_data() {
    const dataList = [
      {
        wrapper_dom: '.ug_fbv1-container .ug_fbv1-inner_left',
        dom: 'a.ug_fbv1-inner_item-img',
        text_dom: '.ug_fbv1-inner_item-info a',
        event_name: 'click_button',
        log_name: '视频中心页面 Top 大图卡片点击',
        module: 'Video Center Top',
        position: 'Video Center Top Big Image',
      },
      {
        dom: '.ug_fbv1-container .ug_fbv1-inner_right .ug_fbv1-inner_item .ug_fbv1-inner_item-info a',
        event_name: 'click_button',
        log_name: '视频中心页面 Top 卡片点击',
        module: 'Video Center Top',
        position: 'Video Center Top Text',
      },
      {
        wrapper_dom:
          '.ug_fbv1-container .ug_fbv1-inner_right .ug_fbv1-inner_item',
        dom: '.ug_fbv1-inner_item-img',
        text_dom: '.ug_fbv1-inner_item-info a',
        event_name: 'click_button',
        log_name: '视频中心页面 Top 卡片点击',
        module: 'Video Center Top',
        position: 'Video Center Top Image',
      },
      {
        dom: '.ug_blog-container .ug_blog-tags-box ul.ug_blog-tags > li',
        event_name: 'click_button',
        log_name: '视频中心页面 Tabs 点击',
        module: 'Video Center Tabs',
        position: 'Video Center Tabs',
      },
      {
        dom: '.ug_blog-container #view_all',
        event_name: 'click_button',
        button_name: 'Load More',
        log_name: '视频中心页面 加载更多按钮点击',
        module: 'Video Center Bottom',
      },
    ];
    dom_listen_click(dataList);
    const init_video_listen = () => {
      const video_items = document.querySelectorAll(
        '.ug_blog-container .ug_post-list .ug-post-card'
      );
      video_items.forEach(function (item) {
        const video_item = item.querySelector('.post-card-cover');
        if (!video_item) return;
        // Check if already has listener
        if (video_item.hasAttribute('data-has-listener')) return;

        video_item.addEventListener('click', function () {
          const video_title = item.querySelector('.post-card-info').innerText;
          Shopify.analytics.publish('ga4Event', {
            log_name: '视频中心页面 视频播放',
            event_name: 'click_button',
            event_parameters: {
              module: 'Video Center Bottom',
              button_name: video_title,
            },
          });
        });

        // Mark as having listener
        video_item.setAttribute('data-has-listener', 'true');
      });
    };
    init_video_listen();
    const need_update_doms = [
      '.ug_blog-container .ug_blog-tags-box ul.ug_blog-tags > li',
      '.ug_blog-container #view_all',
    ];
    // 监听需要更新的dom
    need_update_doms.forEach(function (item) {
      const doms = document.querySelectorAll(item);
      if (!doms?.length) return;
      doms.forEach(function (dom) {
        dom.addEventListener('click', function () {
          init_video_listen();
        });
      });
    });
  }
  /************************ /pages/media-center **************************/
  function ga4_media_center_page_data() {
    const dataList = [
      {
        dom: '.ug-blog-featured a.ug-blog-featured__item',
        text_dom: '.ug-blog-featured__item__content',
        event_name: 'click_button',
        log_name: '媒体中心页面 卡片点击',
        module: 'Media Center Top',
        position: 'Media Center Top',
      },
      {
        dom: '.ug_blog-container .ug-post-card .post-card-info a',
        event_name: 'click_button',
        log_name: '媒体中心页面 卡片点击 Text',
        module: 'Media Center Bottom',
        position: 'Media Center Bottom Text',
      },
      {
        wrapper_dom: '.ug_blog-container .ug-post-card',
        dom: 'a.post-card-cover',
        event_name: 'click_button',
        log_name: '媒体中心页面 卡片点击 Image',
        module: 'Media Center Bottom',
        position: 'Media Center Bottom Image',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/blogs **************************/
  function ga4_blogs_page_data() {
    const dataList = [
      // 博客中心
      {
        dom: '.ug-blog-featured a.ug-blog-featured__item',
        text_dom: '.ug-blog-featured__item__content h3',
        event_name: 'click_button',
        log_name: '博客页面 卡片点击 Top',
        module: 'Blog Top',
        position: 'Blog Top',
      },
      {
        dom: '.ug_blog-container .ug_blog-tags-box ul.ug_blog-tags > li',
        event_name: 'click_button',
        log_name: '博客页面 标签点击',
        module: 'Blog Tabs',
        position: 'Blog Tabs',
      },
      {
        dom: '.ug_blog-container #view_all',
        event_name: 'click_button',
        button_name: 'Load More',
        log_name: '博客页面 加载更多按钮',
        module: 'Blog Bottom',
        position: 'Blog Bottom',
      },
    ];
    dom_listen_click(dataList);

    const init_blog_listen = () => {
      const blog_items = document.querySelectorAll(
        '.ug_blog-container .ug-post-card'
      );
      blog_items.forEach(function (item) {
        const blog_items = item.querySelectorAll('a');
        if (!blog_items?.length) return;
        blog_items.forEach(function (aItem) {
          if (aItem.hasAttribute('data-has-listener')) return;
          aItem.addEventListener('click', function () {
            const button_name = item.querySelector('.post-card-info').innerText;
            Shopify.analytics.publish('ga4Event', {
              log_name: '博客页面 卡片点击',
              event_name: 'click_button',
              event_parameters: {
                module: 'Blog Bottom',
                button_name,
              },
            });
            aItem.setAttribute('data-has-listener', 'true');
          });
        });
      });
    };
    init_blog_listen();
    const need_update_doms = [
      '.ug_blog-container .ug_blog-tags-box ul.ug_blog-tags > li',
      '.ug_blog-container #view_all',
    ];
    // 监听需要更新的dom
    need_update_doms.forEach(function (item) {
      const doms = document.querySelectorAll(item);
      if (!doms?.length) return;
      doms.forEach(function (dom) {
        dom.addEventListener('click', function () {
          init_blog_listen();
        });
      });
    });
  }
  /************************ /pages/app-download **************************/
  function ga4_app_download_page_data() {
    const dataList = [
      {
        dom: '.ug-app-downloaddiv a.ug-app-download-ios',
        event_name: 'click_button',
        button_name: 'Apple App Store',
        log_name: 'App Store 下载按钮点击',
        module: 'UGREEN NAS Download App',
      },
      {
        dom: '.ug-app-downloaddiv a.ug-app-download-google',
        event_name: 'click_button',
        button_name: 'Google Play',
        log_name: 'Google Play 下载按钮点击',
        module: 'UGREEN NAS Download App',
      },
      {
        wrapper_dom: '.mac_download',
        dom: '.ug-downloads-button',
        event_name: 'click_button',
        button_name: 'Mac Download',
        log_name: 'Mac 下载按钮点击',
        module: 'UGREEN NAS Download File',
      },
      {
        wrapper_dom: '.appletv_download',
        dom: '.ug-downloads-button',
        button_name: 'Apple TV Download',
        event_name: 'click_button',
        log_name: 'Apple TV 下载按钮点击',
        module: 'UGREEN NAS Download File',
      },
      {
        wrapper_dom: '.win_download',
        dom: '.ug-downloads-button',
        button_name: 'Windows Download',
        event_name: 'click_button',
        log_name: 'Windows 下载按钮点击',
        module: 'UGREEN NAS Download File',
      },
      {
        wrapper_dom: '.androidtv_download',
        dom: '.ug-downloads-button',
        button_name: 'Android TV Download',
        event_name: 'click_button',
        log_name: 'Android TV 下载按钮点击',
        module: 'UGREEN NAS Download File',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ /pages/policy **************************/
  function ga4_policy_page_data() {
    const dataList = [
      {
        dom: '.ug-legal-documents-tittle',
        event_name: 'click_button',
        log_name: '隐私政策页面 标题点击',
        module: 'Privacy Policy',
      },
      {
        dom: '.legal_histroy-btn',
        event_name: 'click_button',
        button_name: 'History Version',
        log_name: '隐私政策页面 历史版本点击',
        module: 'Privacy Policy',
      },
    ];
    dom_listen_click(dataList);
  }

  /************************ 购物车模块 **************************/
  function ga4_cart_data() {
    // 选择要监听的父容器
    const miniCartContainer = document.querySelector('#t4s-mini_cart');

    // 使用事件委托监听父容器的点击事件
    miniCartContainer?.addEventListener('click', function (event) {
      // 检查点击的元素的祖先是否是加号按钮
      if (event.target.closest('.t4s-quantity-selector.is--plus')) {
        const target = event.target.closest('[data-ga4-product]');
        const product_list_data = [
          Object.assign(
            {},
            JSON.parse(target.getAttribute('data-ga4-product')),
            { quantity: 1 }
          ),
        ];

        add_to_cart_data_reporting(
          {
            button_name: 'Mini Cart Plus Button',
            position: 'Mini Cart',
            item_list_id: item_list_id,
            item_list_name: item_list_name,
          },
          product_list_data
        );
      }

      // 检查点击的元素的祖先是否是减号按钮
      if (event.target.closest('.t4s-quantity-selector.is--minus')) {
        const target = event.target.closest('[data-ga4-product]');
        const product_list_data = [
          Object.assign(
            {},
            JSON.parse(target.getAttribute('data-ga4-product')),
            { quantity: 1, item_list_id: item_list_id, item_list_name: item_list_name }
          ),
        ];
        const value = product_list_data.reduce(
          (total, item) => total + item.price * item.quantity,
          0
        );
        Shopify.analytics.publish('ga4Event', {
          log_name: '产品减购按钮点击:',
          event_name: 'remove_from_cart',
          event_parameters: {
            items: product_list_data,
            button_name: 'Mini Cart Minus Button',
            position: 'Mini Cart',
            value: value,
            currency: currency,
            item_list_id: item_list_id,
            item_list_name: item_list_name,
          },
        });
      }

      // 检查点击的元素的祖先是否是删除按钮
      if (event.target.closest('.t4s-mini_cart__remove')) {
        const target = event.target.closest('[data-ga4-product]');
        const quantity =
          target.querySelector('.t4s-quantity-input')?.value || 1;
        const product_list_data = [
          Object.assign(
            {},
            JSON.parse(target.getAttribute('data-ga4-product')),
            { quantity: Number(quantity), item_list_id: item_list_id, item_list_name: item_list_name }
          ),
        ];
        const value = product_list_data.reduce(
          (total, item) => total + item.price * item.quantity,
          0
        );

        Shopify.analytics.publish('ga4Event', {
          log_name: '删除按钮:',
          event_name: 'remove_from_cart',
          event_parameters: {
            items: product_list_data,
            button_name: 'Mini Cart Minus Button',
            position: 'Mini Cart',
            item_list_id: item_list_id,
            item_list_name: item_list_name,
            value: value,
            currency: currency,
          },
        });
      }

      // 检查点击的元素的祖先是否是 checkout 按钮
      if (event.target.closest('.t4s-btn__checkout')) {
        const button_name = 'Checkout Button';

        ga4_dealy_report({
          log_name: '跳转 checkout 按钮:',
          event_name: 'click_checkout_button',
          event_parameters: {
            module: 'Checkout Module',
            button_name,
            position: 'Mini Cart',
          },
        });
      }

      // 检查点击的元素的祖先是否是 view cart 按钮
      if (event.target.closest('.t4s-btn__cart')) {
        const button_name = 'View Cart Button';

        ga4_dealy_report({
          log_name: '跳转 Main Cart 按钮:',
          event_name: 'click_view_cart_button',
          event_parameters: {
            module: 'Checkout Module',
            button_name,
            position: 'Mini Cart',
          },
        });
      }

      // 检查点击的元素的祖先是否是运费预估按钮
      if (event.target.closest('.t4s-get__rates')) {
        const button_name = 'Estimated';
        const module =
          window.UGrequest.page_type === 'cart' ? 'Cart Page' : 'Cart Sidebar';

        Shopify.analytics.publish('ga4Event', {
          log_name: '获取运费按钮:',
          event_name: 'freight_estimate',
          event_parameters: {
            module: module,
            button_name,
            position: 'Mini Cart',
          },
        });
      }

      // 检查点击的元素的祖先是否是输入框
      if (event.target.closest('.t4s-quantity-input')) {
        const target = event.target.closest('[data-ga4-product]');
        const input = target.querySelector('.t4s-quantity-input');

        // 检查是否已经添加了监听器
        if (!input.dataset.listenerAdded) {
          const old_quantity = input.value || 1;
          input.addEventListener('change', (event) => {
            const new_quantity = event.target.value || 1;

            if (new_quantity !== old_quantity) {
              const quantity_change = new_quantity - old_quantity;
              const product_list_data = [
                Object.assign(
                  {
                    item_list_id: item_list_id,
                    item_list_name: item_list_name,
                  },
                  JSON.parse(target.getAttribute('data-ga4-product')),
                  { quantity: Math.abs(quantity_change) }
                ),
              ];
              const value = product_list_data.reduce(
                (total, item) => total + item.price * item.quantity,
                0
              );
              if (quantity_change > 0) {
                Shopify.analytics.publish('ga4Event', {
                  log_name: 'input 修改 加购:',
                  event_name: 'add_to_cart',
                  event_parameters: {
                    items: product_list_data,
                    button_name: 'Mini Cart Input',
                    position: 'Mini Cart',
                    item_list_id: item_list_id,
                    item_list_name: item_list_name,
                    value: value,
                    currency: currency,
                  },
                });
              } else {
                Shopify.analytics.publish('ga4Event', {
                  log_name: 'input 修改 减购:',
                  event_name: 'remove_from_cart',
                  event_parameters: {
                    items: product_list_data,
                    button_name: 'Mini Cart Input',
                    position: 'Mini Cart',
                    item_list_id: item_list_id,
                    item_list_name: item_list_name,
                    value: value,
                    currency: currency,
                  },
                });
              }
            }
          });

          // 标记监听器已添加
          input.dataset.listenerAdded = true;
        }
      }
    });
  }

  /************************ 专辑页 **************************/
  function ga4_collection_data() {
    const select_items = document.querySelectorAll('.facets-container select');
    select_items.forEach(function (item) {
      item?.addEventListener('change', function (event) {
        const button_name = item.selectedOptions[0].text;
        Shopify.analytics.publish('ga4Event', {
          log_name: '专辑页顶部筛选按钮',
          event_name: 'click_button',
          event_parameters: {
            button_name,
            module: 'Collection',
          },
        });
      });
    });

    const dataList = [
      {
        wrapper_dom: 'ug-faq-accordion',
        dom: '.accordion-container .ac',
        event_name: 'click_button',
        log_name: '专辑页 FAQ 点击',
        module: 'Collection',
      },
    ];
    dom_listen_click(dataList);
  }
  /************************ 产品页 **************************/
  // 页面加载上报
  function ga4_product_detail_data() {
    const product_info = window.UGrequest.product_info;
    Shopify.analytics.publish('ga4Event', {
      log_name: '产品详情页加载',
      event_name: 'view_item',
      event_parameters: {
        position: 'product_detail',
        currency: currency,
        value: product_info.price,
        item_list_id: item_list_id,
        item_list_name: item_list_name,
        items: [
          Object.assign(
            { item_list_id: item_list_id, item_list_name: item_list_name },
            product_info,
            product_info?.variants
              ? product_info.variants.find((item) => item.selected)
              : {}
          ),
        ],
      },
    });

    // 监听 variant-selects 的 change：选项（颜色/尺码等）变化后，由组件已更新表单的 variant id，再根据 id 在 variants 中取对应变体上报
    const variantSelectsEl = document.querySelector('variant-selects');
    if (variantSelectsEl) {
      variantSelectsEl.addEventListener('change', function () {
        const sectionId = this.dataset?.section;
        if (!sectionId) return;
        const form = document.getElementById('product-form-' + sectionId) || document.getElementById('sticky-product-form-' + sectionId);
        const variantIdInput = form?.querySelector('input[name="id"]');
        const variantId = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
        if (variantId == null || isNaN(variantId)) return;
        const product_info = window.UGrequest?.product_info;
        if (!product_info?.variants) return;
        const variantIndex = product_info.variants.findIndex(function (v) {
          return v.item_id === variantId;
        });
        if (variantIndex === -1) return;
        ga4_product_variant_data(variantIndex);
      });
    }
  }
  // 子款式切换上报（index 为 product_info.variants 的数组下标，非选项单选按钮顺序）
  function ga4_product_variant_data(index) {
    if (index === undefined) return;
    const product_info = window.UGrequest?.product_info;
    if (!product_info?.variants) return;
    const variants = product_info.variants;
    if (index < 0 || index >= variants.length) return;
    variants.forEach(function (item, k) {
      item.selected = k === index;
    });
    Shopify.analytics.publish('ga4Event', {
      log_name: '产品详情页子款式切换:',
      event_name: 'view_item',
      event_parameters: {
        position: 'product_variant_select',
        currency: currency,
        value: product_info.price,
        item_list_id: item_list_id,
        item_list_name: item_list_name,
        items: [
          {
            item_list_id: item_list_id,
            item_list_name: item_list_name,
            ...product_info,
            ...variants[index],
          },
        ],
      },
    });
  }
  // 产品信息区域按钮点击
  function ga4_product_info_area_data() {
    const product_a_plus_items = [
      {
        button_name: 'breadcrumb',
        dom: '.t4s-dib',
        event_name: 'click_button',
        log_name: '面包屑',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Product Carousel Previous',
        dom: '.product__media-wrapper media-gallery .gallery-nav.prev',
        event_name: 'click_button',
        log_name: '产品轮播上一页按钮',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Product Carousel Next',
        dom: '.product__media-wrapper .gallery-nav.next',
        event_name: 'click_button',
        log_name: '产品轮播下一页按钮',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Product Image Carousel',
        dom: '.product__media-wrapper .product-gallery__thumbnails-wrapper .thumbnail-button',
        event_name: 'click_button',
        log_name: '产品缩略图轮播按钮',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Product Carousel Zoom',
        dom: '.product__media-wrapper .zoom-button',
        event_name: 'click_button',
        log_name: '产品轮播放大按钮',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Discount Copy',
        dom: '.product__info-wrapper .ug-product-discount .ug-product-discount-btn',
        event_name: 'click_button',
        log_name: '折扣复制按钮',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Show Short Description',
        dom: '.product__info-wrapper .ug-product-short-desc',
        event_name: 'click_button',
        log_name: '展开短描述 Body 点击',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Show Short Description Learn More',
        dom: '.product__info-wrapper .foldBtn-wrap',
        event_name: 'click_button',
        log_name: '显示短描述按钮 Learn More 按钮',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Klarna Placement',
        dom: '.product__info-wrapper .klarna-placement',
        event_name: 'click_button',
        log_name: 'Klarna 按钮',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Jump to Review',
        dom: '.product__info-wrapper .scm-reviews-rate',
        event_name: 'click_button',
        log_name: '跳到 Review 按钮',
        module: 'Product Detail Info Area',
      },
      {
        button_name: 'Jump seel',
        dom: '.product__info-wrapper .seel--product_tip--info-icon',
        event_name: 'click_button',
        log_name: '跳到 seel 按钮',
        module: 'Product Detail Info Area',
      },
      {
        dom: '.product-tabs__nav .product-tabs__button',
        event_name: 'click_button',
        log_name: '产品 tabs 切换',
        module: 'Product Detail Tabs',
      },
    ];
    dom_listen_click(product_a_plus_items);
  }

  // 产品A+区域点击
  function ga4_product_a_plus_data() {
    const product_a_plus_items = [
      {
        button_name: 'video play btn',
        dom: '.product-tabs__content .ug-m3u8-video-itemdiv',
        event_name: 'click_button',
        log_name: '视频播放按钮',
        module: 'Product Detail Overview',
      },
      {
        button_name: 'aplus-goto-btn',
        dom: '.product-tabs__content .aplus-goto-btn',
        event_name: 'click_button',
        log_name: 'A+按钮',
        module: 'Product Detail Overview',
      },
      {
        button_name: 'a-carousel-goto-prevpage',
        dom: '.product-tabs__content .a-carousel-goto-prevpage',
        event_name: 'click_button',
        log_name: '上一页按钮',
        module: 'Product Detail Overview',
      },
      {
        button_name: 'a-carousel-goto-nextpage',
        dom: '.product-tabs__content .a-carousel-goto-nextpage',
        event_name: 'click_button',
        log_name: '下一页按钮',
        module: 'Product Detail Overview',
      },
      {
        button_name: 'ug-custom-desc-carousel-btn',
        dom: '.product-tabs__content .ug-custom-desc-carousel-btn',
        event_name: 'click_button',
        log_name: '自定义描述轮播按钮',
        module: 'Product Detail Overview',
      },
      {
        button_name: 'Custom Desc Carousel Next',
        dom: '.product-tabs__content .swiper-button-next',
        event_name: 'click_button',
        log_name: '自定义轮播下一页',
        module: 'Product Detail Overview',
      },
      {
        button_name: 'Custom Desc Carousel Prev',
        dom: '.product-tabs__content .swiper-button-prev',
        event_name: 'click_button',
        log_name: '自定义轮播上一页',
        module: 'Product Detail Overview',
      },
    ];
    dom_listen_click(product_a_plus_items);
  }
  // FAQ
  function ga4_product_faq_data() {
    const module = 'FAQ';
    const dataList = [
      {
        button_name: 'faq title',
        dom: '#FAQ .simpQuestionHolder',
        event_name: 'click_button',
        log_name: 'FAQ 标题',
      },
    ];
    dom_listen({ dataList, module });
  }

  function ga4_product_add_to_cart_data() {
    const product_info = window.UGrequest.product_info;
    const add_to_cart_btn = document.querySelector(
      '.product__info-container .product-form__buttons button[type="submit"]'
    );
    add_to_cart_btn?.addEventListener('click', function (event) {
      const quantity =
        document.querySelector(
          '.product__info-container .product-form__quantity input.quantity__input'
        )?.value || 1;
      const product_list_data = [
        Object.assign(
          {},
          product_info,
          product_info?.variants
            ? product_info.variants.find((item) => item.selected)
            : {},
          { quantity: Number(quantity) }
        ),
      ];
      add_to_cart_data_reporting(
        {
          button_name: 'Add To Cart',
          position: 'product_detail',
          item_list_id: item_list_id,
          item_list_name: item_list_name,
        },
        product_list_data
      );
    });
    setTimeout(() => {
      const sticky_atc = document.querySelector(
        '.sticky-bottom-bar .product-form__buttons button[type="submit"]'
      );
      sticky_atc?.addEventListener('click', function (event) {
        const quantity =
          document.querySelector(
            '.sticky-bottom-bar .product-form__quantity input.quantity__input'
          )?.value || 1;
        const product_list_data = [
          Object.assign(
            {},
            product_info,
            product_info?.variants
              ? product_info.variants.find((item) => item.selected)
              : {},
            { quantity: Number(quantity) }
          ),
        ];
        add_to_cart_data_reporting(
          {
            button_name: 'Add To Cart',
            position: 'sticky_atc',
            item_list_id: item_list_id,
            item_list_name: item_list_name,
          },
          product_list_data
        );
      });
    });
  }
  /************************ 购物车 **************************/
  function ga4_mini_cart_data() {
    const mini_cart = document.querySelector('cart-drawer.drawer');
    if (!mini_cart) return;
    let has_cart_dom_listen = false;
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('active')
        ) {
          const product_list_data = [];
          mini_cart.querySelectorAll('[data-ga4-product]').forEach((item) => {
            const product_data = JSON.parse(item.getAttribute('data-ga4-product'));
            product_list_data.push(
              Object.assign(product_data, {
                item_list_id: item_list_id,
                item_list_name: item_list_name,
              })
            );
          });
          const total_price = Number(
            mini_cart
              .querySelector('.totals__total-value')
              ?.getAttribute('data-total-price') || 0
          );
          product_list_data.forEach((item) => {
            if (item.total_discount) {
              item.discount = item.total_discount;
              item.item_list_id = item_list_id;
              item.item_list_name = item_list_name;
            }
          });
          Shopify.analytics.publish('ga4Event', {
            log_name: 'mini cart 曝光',
            event_name: 'view_cart',
            event_parameters: {
              currency: currency,
              value: total_price,
              items: product_list_data,
              position: 'mini_cart',
            },
          });
          if (!has_cart_dom_listen) {
            has_cart_dom_listen = true;
            ga4_cart_dom_listen(mini_cart);
          }
        }
      });
    });
    observer.observe(mini_cart, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
  function ga4_main_cart_data() {
    const main_cart = document.querySelector('#main-cart-items');
    if (!main_cart) return;
    const cart_items = main_cart.querySelectorAll('[data-ga4-product]');
    const product_list_data = [];
    cart_items.forEach((item) => {
      const product_data = JSON.parse(item.getAttribute('data-ga4-product'));
      product_list_data.push(
        Object.assign(product_data, {
          item_list_id: item_list_id,
          item_list_name: item_list_name,
        })
      );
    });
    setTimeout(() => {
      const value = Number(
        document
          .querySelector('.totals__total-value')
          ?.getAttribute('data-total-price') || 0
      );
      product_list_data.forEach((item) => {
        if (item.total_discount) {
          item.discount = item.total_discount;
          item.item_list_id = item_list_id;
          item.item_list_name = item_list_name;
        }
      });
      Shopify.analytics.publish('ga4Event', {
        log_name: 'main cart 曝光',
        event_name: 'view_cart',
        event_parameters: {
          currency: currency,
          value: value,
          position: 'Main Cart',
          items: product_list_data,
        },
      });
    }, 1000);

    ga4_cart_dom_listen(main_cart, 'Main Cart');
    // 跳转 checkout 按钮 补充
    document
      .querySelector('.cart__footer-wrapper button.cart__checkout-button')
      .addEventListener('click', function (event) {
        ga4_dealy_report({
          log_name: '跳转 checkout 按钮',
          event_name: 'click_checkout_button',
          event_parameters: {
            module: 'Cart Module',
            button_name: 'Checkout Button',
            position: 'Main Cart',
          },
        });
      });
  }
  function ga4_cart_dom_listen(cart, position = 'Mini Cart') {
    // 使用事件委托监听父容器的点击事件
    cart?.addEventListener('click', function (event) {
      // 使用一次性的元素匹配,避免重复查询DOM
      const clickedElement = event.target;
      const productContainer = clickedElement.closest('[data-ga4-product]');

      // 如果点击的不是产品容器内的元素,直接返回
      if (!productContainer) return;

      // 一次性获取产品数据,避免重复解析
      const productData = JSON.parse(
        productContainer.getAttribute('data-ga4-product')
      );

      // 使用Map存储按钮选择器和对应的处理函数
      const buttonHandlers = new Map([
        [
          'button.quantity__button[name="plus"]',
          () => {
            const product_list_data = [
              Object.assign({}, productData, { quantity: 1 }, { item_list_id: item_list_id, item_list_name: item_list_name }),
            ];

            add_to_cart_data_reporting(
              {
                button_name: position + ' Plus Button',
                position: position,
              },
              product_list_data
            );
          },
        ],
        [
          'button.quantity__button[name="minus"]',
          () => {
            const product_list_data = [
              Object.assign({}, productData, { quantity: 1 }, { item_list_id: item_list_id, item_list_name: item_list_name }),
            ];
            const value =
              product_list_data[0].price * product_list_data[0].quantity;

            Shopify.analytics.publish('ga4Event', {
              log_name: '产品减购按钮点击:',
              event_name: 'remove_from_cart',
              event_parameters: {
                items: product_list_data,
                button_name: position + ' Minus Button',
                position: position,
                value: value,
                currency: currency,
              },
            });
          },
        ],
        [
          'cart-remove-button',
          () => {
            const quantity =
              productContainer.querySelector('input.quantity__input')?.value ||
              1;
            const discount = productData.discount * Number(quantity);
            const product_list_data = [
              Object.assign({}, productData, { quantity: Number(quantity) }, { item_list_id: item_list_id, item_list_name: item_list_name }),
            ];
            const value =
              product_list_data[0].price * product_list_data[0].quantity;

            Shopify.analytics.publish('ga4Event', {
              log_name: '删除按钮:',
              event_name: 'remove_from_cart',
              event_parameters: {
                items: product_list_data,
                button_name: position + ' Remove Button',
                position: position,
                value: value,
                currency: currency,
              },
            });
          },
        ],
        [
          'button.cart__checkout-button',
          () => {
            ga4_dealy_report({
              log_name: '跳转 checkout 按钮:',
              event_name: 'click_checkout_button',
              event_parameters: {
                module: 'Checkout Module',
                button_name: position + ' Checkout Button',
                position: position,
              },
            });
          },
        ],
        [
          'button.cart__view-cart-button',
          () => {
            ga4_dealy_report({
              log_name: '跳转 Main Cart 按钮:',
              event_name: 'click_view_cart_button',
              event_parameters: {
                module: 'Checkout Module',
                button_name: position + ' View Cart Button',
                position: position,
              },
            });
          },
        ],
        [
          'input.quantity__input',
          () => {
            const target = productContainer;
            const input = target.querySelector('.quantity__input');

            // 检查是否已经添加了监听器
            if (!input.dataset.listenerAdded) {
              const old_quantity = input.value || 1;
              input.addEventListener('change', (event) => {
                const new_quantity = event.target.value || 1;

                if (new_quantity !== old_quantity) {
                  const quantity_change = new_quantity - old_quantity;
                  const product_list_data = [
                    Object.assign(
                      { item_list_id: item_list_id, item_list_name: item_list_name },
                      JSON.parse(target.getAttribute('data-ga4-product')),
                      { quantity: Math.abs(quantity_change) },
                      {
                        discount:
                          productData.discount * Math.abs(quantity_change),
                      }
                    ),
                  ];
                  const value = product_list_data.reduce(
                    (total, item) => total + item.price * item.quantity,
                    0
                  );
                  if (quantity_change > 0) {
                    Shopify.analytics.publish('ga4Event', {
                      log_name: 'input 修改 加购:',
                      event_name: 'add_to_cart',
                      event_parameters: {
                        items: product_list_data,
                        button_name: position + ' Input',
                        position: position,
                        value: value,
                        currency: currency,
                      },
                    });
                  } else {
                    Shopify.analytics.publish('ga4Event', {
                      log_name: 'input 修改 减购:',
                      event_name: 'remove_from_cart',
                      event_parameters: {
                        items: product_list_data,
                        button_name: position + ' Input',
                        position: position,
                        value: value,
                        currency: currency,
                      },
                    });
                  }
                }
              });

              // 标记监听器已添加
              input.dataset.listenerAdded = true;
            }
          },
        ],
      ]);

      // 查找并执行匹配的处理函数
      for (const [selector, handler] of buttonHandlers) {
        if (clickedElement.closest(selector)) {
          handler();
          break;
        }
      }
    });
  }
  /************************ 博客页面 **************************/
  function ga4_article_data() {
    const dataList = [
      // 博客内容
      {
        dom: '#bloggle-article-new .bloggle-article-new_breadcrumb_flex a.bloggle-article-new_breadcrumb_link',
        event_name: 'click_button',
        log_name: '博客页面 面包屑点击',
        module: 'Blog Article Breadcrumb',
      },
      {
        dom: '#bloggle-article-new .bloggle-article-new_header_tags a.bloggle-article-new_header_tags_item',
        event_name: 'click_button',
        log_name: '博客页面 标签点击',
        module: 'Blog Article Tags',
      },
      {
        dom: '#bloggle-article-new .bloggle-article-new_header_info_social a:first-child',
        event_name: 'click_button',
        button_name: 'Facebook',
        log_name: '博客页面 分享按钮点击 Facebook',
        module: 'Blog Article Share',
      },
      {
        dom: '#bloggle-article-new .bloggle-article-new_header_info_social a:nth-child(2)',
        event_name: 'click_button',
        button_name: 'Twitter',
        log_name: '博客页面 分享按钮点击 Twitter',
        module: 'Blog Article Share',
      },
      {
        dom: '#bloggle-article-new .bloggle-article-new_header_info_social a:nth-child(3)',
        event_name: 'click_button',
        button_name: 'Pinterest',
        log_name: '博客页面 分享按钮点击 Pinterest',
        module: 'Blog Article Share',
      },
      {
        dom: '#bloggle-article-new .bloggle-article-new_h2div .bloggle-article-new-menu_li a.bloggle-article-new-menu_li',
        event_name: 'click_button',
        log_name: '博客页面 Nav 点击',
        module: 'Blog Article Nav',
      },
      {
        wrapper_dom: '#bloggle-article-new .bloggle-article-new_content_inpd',
        dom: 'a',
        except_dom: [
          '.ug-bloggle-article-new-imgdiv',
          '.ug-bloggle-article-new-title-wrapper',
          '.ug-bloggle-article-new-learn-btn',
        ],
        event_name: 'click_button',
        log_name: '博客页面 文章内容点击',
        module: 'Blog Article Content',
      },
      {
        dom: '#bloggle-article-new .bloggle-article-new_featurediv .bloggle-article-new-FEATURE-item',
        event_name: 'click_button',
        text_dom: '.bloggle-article-new_feature_item_title',
        log_name: '博客页面 关联文章点击',
        module: 'Blog Article Related Article',
      },
      // 老博客模板
      {
        dom: '#bloggle_article .bloggle_rte a',
        event_name: 'click_button',
        log_name: '博客页面 老博客模板 链接点击',
        module: 'Blog Article Old Template',
      },
      {
        dom: '#bloggle_article .share-buttons .twitter-share',
        event_name: 'click_button',
        button_name: 'Twitter',
        log_name: '博客页面 老博客模板 推特分享按钮点击',
        module: 'Blog Article Old Template',
      },
      {
        dom: '#bloggle_article .share-buttons .facebook-share',
        event_name: 'click_button',
        button_name: 'Facebook',
        log_name: '博客页面 老博客模板 脸书分享按钮点击',
        module: 'Blog Article Old Template',
      },
      {
        dom: '#bloggle_article .share-buttons .pinterest-share',
        event_name: 'click_button',
        button_name: 'Pinterest',
        log_name: '博客页面 老博客模板 推特分享按钮点击',
        module: 'Blog Article Old Template',
      },
    ];
    dom_listen_click(dataList);
  }

  /************************ 登录页 **************************/
  if (
    window.UGrequest.page_type === 'customers/account' &&
    (document.referrer.includes('login') ||
      document.referrer.includes('challenge'))
  ) {
    // 登录按钮
    function ga4_login_data() {
      Shopify.analytics.publish('ga4Event', {
        event_name: 'login',
      });
    }
    ga4_login_data();
  }
  /************************ 注册页 **************************/
  if (
    window.UGrequest.page_type === 'index' &&
    document.referrer.includes('register') &&
    window.UGrequest.CUSTOMER_ID
  ) {
    // 注册按钮
    function ga4_register_data() {
      Shopify.analytics.publish('ga4Event', {
        event_name: 'sign_up',
      });
    }
    ga4_register_data();
  }

  class UgGa4Track extends HTMLElement {
    constructor() {
      super();
      // 创建并附加一个开放的 Shadow DOM
      this.attachShadow({ mode: 'open' });
      this.module = this.getAttribute('module');
      this.button_name = this.getAttribute('button_name');
      this.log_name = this.getAttribute('log_name');
      this.item_list_id = sessionStorage.getItem('item_list_id');
      this.item_list_name = sessionStorage.getItem('item_list_name');
      this.page_number = this.getAttribute('page_number') || '';
      this.type = this.getAttribute('type');
      this.position = this.getAttribute('position');
      // 购物车总价
      this.total_price = this.getAttribute('total_price');
      // banner 曝光
      this.creative_slot = this.getAttribute('creative_slot');
      this.creative_name = this.getAttribute('creative_name');
      this.creative_id = this.getAttribute('creative_id');
      this.index = this.getAttribute('index');
      this.shadowRoot.innerHTML = `
        <slot></slot>
      `;
    }

    connectedCallback() {
      if (this.type === 'product-list-exposure') {
        this.initObserver();
      }
      // 产品点击
      if (this.type === 'product-click') {
        this.productClickListener();
      }
      // banner 曝光
      if (this.type === 'banner-exposure') {
        this.bannerExposure();
      }
      // swiper banner 曝光
      if (this.type === 'swiper-banner-exposure') {
        this.swiperBannerExposure();
      }
      // button click
      if (this.type === 'button-click') {
        this.buttonClick();
      }
      // mega menu 曝光
      if (this.type === 'mega-menu-exposure') {
        this.megaMenuExposure();
      }
    }
    // 初始化 IntersectionObserver
    initObserver() {
      const slot = this.shadowRoot.querySelector('slot');
      if (slot.assignedElements().length > 0) {
        // 获取分配的第一个元素（即插槽内的内容）
        const target = slot.assignedElements()[0];
        // 使用 IntersectionObserver 观察这个目标元素
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // 当元素进入视口时触发曝光上报
                this.reportExposure();
                // 产品点击
                this.productClickListener();
                // 如果只需要一次曝光上报，可以在这里停止观察
                observer.disconnect();
              }
            });
          },
          {
            threshold: 0.5, // 当50%的内容出现在视口时，认为其曝光
          }
        );

        // 观察分配到 slot 的第一个元素
        observer.observe(target);
      }
    }

    reportExposure() {
      const product_list = this.querySelectorAll('[data-ga4-product]');

      const product_list_data = [];
      product_list.forEach((item) => {
        const product_data = JSON.parse(item.getAttribute('data-ga4-product'));
        product_list_data.push(
          Object.assign(product_data, {
            item_list_id: this.item_list_id,
            item_list_name: this.item_list_name,
          })
        );
      });
      const event_parameters = {
        currency: currency,
        items: product_list_data,
      };
      if (this.page_number) {
        event_parameters.page_number = this.page_number;
      }
      if (this.position) {
        event_parameters.position = this.position;
      }

      Shopify.analytics.publish('ga4Event', {
        event_name: 'view_item_list',
        log_name: this.log_name || '产品列表曝光',
        event_parameters: event_parameters,
      });
    }

    // 产品点击事件，包含加购
    productClickListener() {
      const product_list = this.querySelectorAll('[data-ga4-product]');
      product_list.forEach((item) => {
        item.addEventListener('click', (event) => {
          const product_data = JSON.parse(item.getAttribute('data-ga4-product'));
          const product_list_data = [
            Object.assign(product_data, {
              item_list_id: this.item_list_id,
              item_list_name: this.item_list_name,
            }),
          ];
          const isAddToCartBtn =
            event.currentTarget.classList.contains('quick-add__submit') ||
            event.target.classList.contains('product-form__submit') ||
            event.target.closest('.quick-add__submit') ||
            event.target.closest('.product-form__submit');
          if (isAddToCartBtn) {
            add_to_cart_data_reporting(
              {
                button_name: this.button_name || 'Add To Cart',
                position: this.position || 'product_add_to_cart',
                item_list_id: this.item_list_id,
                item_list_name: this.item_list_name,
              },
              product_list_data
            );
            return;
          }
          if (item.getAttribute('target') === '_blank') {
            Shopify.analytics.publish('ga4Event', {
              log_name: '产品信息区域按钮:',
              event_name: 'select_item',
              event_parameters: {
                items: product_list_data,
                position: this.position || 'product_info_area',
                button_name:
                  this.button_name || event.target.innerText || 'product_click',
                currency: currency,
                item_list_id: this.item_list_id,
                item_list_name: this.item_list_name,
              },
            });
          } else {
            ga4_dealy_report({
              log_name: '产品信息区域按钮:',
              event_name: 'select_item',
              event_parameters: {
                items: product_list_data,
                position: this.position || 'product_info_area',
                button_name:
                  this.button_name || event.target.innerText || 'product_click',
                currency: currency,
                item_list_id: this.item_list_id,
                item_list_name: this.item_list_name,
              },
            });
          }
        });
        item.querySelectorAll('a').forEach((a) => {
          a.addEventListener('click', (event) => {
            const product_data = JSON.parse(item.getAttribute('data-ga4-product'));
            const product_list_data = [
              Object.assign(product_data, {
                item_list_id: this.item_list_id,
                item_list_name: this.item_list_name,
              }),
            ];
            const delay_reporting = a.target === '_blank';
            if (delay_reporting) {
              ga4_dealy_report({
                log_name: '产品信息区域按钮:',
                event_name: 'select_item',
                event_parameters: {
                  items: product_list_data,
                  position: this.position || 'product_info_area',
                  button_name:
                    this.button_name ||
                    event.target.innerText ||
                    'product_click',
                  currency: currency,
                  item_list_id: this.item_list_id,
                  item_list_name: this.item_list_name,
                },
              });
            } else {
              click_event_data_reporting({
                event_name: 'select_item',
                log_name: '产品信息区域按钮:',
                event_parameters: {
                  items: product_list_data,
                  position: this.position || 'product_info_area',
                  button_name:
                    this.button_name ||
                    event.target.innerText ||
                    'product_click',
                  currency: currency,
                },
              });
            }
          });
        });
      });
    }
    // banner 曝光
    bannerExposure() {
      const slot = this.shadowRoot.querySelector('slot');
      if (slot.assignedElements().length > 0) {
        // 获取分配的第一个元素（即插槽内的内容）
        const target = slot.assignedElements()[0];
        // 使用 IntersectionObserver 观察这个目标元素
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // 当元素进入视口时触发曝光上报
                const banner_data = JSON.parse(
                  this.getAttribute('data-ga4-banner')
                );
                const {
                  button_name,
                  button_name2,
                  creative_name,
                  creative_id,
                  creative_slot,
                  index,
                  position,
                } = banner_data;

                Shopify.analytics.publish('ga4Event', {
                  log_name: this.log_name || 'banner 曝光',
                  event_name: 'view_promotion',
                  event_parameters: {
                    promotion_id: creative_id,
                    promotion_name: creative_name,
                    creative_name: creative_name,
                    creative_slot: creative_slot,
                    index: index,
                    position: position,
                  },
                });

                // banner 点击监听
                target.addEventListener('click', () => {
                  Shopify.analytics.publish('ga4Event', {
                    log_name: 'banner 点击',
                    event_name: 'select_promotion',
                    event_parameters: {
                      promotion_id: creative_id,
                      promotion_name: creative_name,
                      creative_name: creative_name,
                      creative_slot: creative_slot,
                      button_name: button_name,
                      index: index,
                      position: position,
                    },
                  });
                });
                // 如果 button_name2 存在，则添加 button_name2 的点击事件
                if (
                  button_name2 &&
                  target.querySelector('[data-ga4-banner-btn2]')
                ) {
                  target
                    .querySelector('[data-ga4-banner-btn2]')
                    .addEventListener('click', () => {
                      Shopify.analytics.publish('ga4Event', {
                        log_name: 'banner第二个按钮 点击',
                        event_name: 'select_promotion',
                        event_parameters: {
                          promotion_id: creative_id,
                          promotion_name: creative_name,
                          creative_name: creative_name,
                          creative_slot: creative_slot,
                          button_name: button_name2,
                          index: index,
                          position: position,
                        },
                      });
                    });
                }
              }
            });
          },
          {
            threshold: 0.5, // 当50%的内容出现在视口时，认为其曝光
          }
        );
        observer.observe(target); // 观察分配到 slot 的第一个元素
      }
    }
    // swiper banner 曝光
    swiperBannerExposure() {
      const slot = this.shadowRoot.querySelector('slot');

      // 用于存储已经曝光的 slide
      const exposedSlides = new Set();

      if (slot.assignedElements().length > 0) {
        const target = slot.assignedElements()[0];
        const swiper_slides = target.querySelectorAll('[data-ga4-banner]');

        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (
              mutation.attributeName === 'class' &&
              (mutation.target.classList.contains('swiper-slide-active') ||
                mutation.target.classList.contains('is-selected'))
            ) {
              const swiper_banner_data = JSON.parse(
                mutation.target.getAttribute('data-ga4-banner')
              );

              // 确保 swiper_banner_data 存在
              if (swiper_banner_data) {
                const {
                  creative_id,
                  creative_name,
                  creative_slot,
                  index,
                  position,
                } = swiper_banner_data;
                // 使用 Set 记录已经曝光的 slide，避免重复上报
                if (!exposedSlides.has(creative_id)) {
                  exposedSlides.add(creative_id); // 将 slide ID 加入 Set

                  Shopify.analytics.publish('ga4Event', {
                    log_name: this.log_name || 'swiper banner 曝光',
                    event_name: 'view_banner',
                    event_parameters: {
                      promotion_id: creative_id,
                      promotion_name: creative_name,
                      creative_name: creative_name,
                      creative_slot: creative_slot,
                      index: index,
                      position: this.position,
                    },
                  });
                }
              }
            }
          });
        });

        // 为每个 slide 设置观察
        swiper_slides.forEach((swiper_slide) => {
          observer.observe(swiper_slide, {
            attributes: true, // 监听属性的变化
            attributeFilter: ['class'], // 只监听 class 属性
          });
          const swiper_banner_data = JSON.parse(
            swiper_slide.getAttribute('data-ga4-banner')
          );
          const {
            button_name,
            button_name2,
            creative_name,
            creative_id,
            creative_slot,
            index,
          } = swiper_banner_data;
          if (
            button_name &&
            swiper_slide.querySelector('[data-ga4-banner-btn]')
          ) {
            swiper_slide
              .querySelector('[data-ga4-banner-btn]')
              .addEventListener('click', () => {
                Shopify.analytics.publish('ga4Event', {
                  log_name: 'swiper banner 点击',
                  event_name: 'click_banner',
                  event_parameters: {
                    promotion_id: creative_id,
                    promotion_name: creative_name,
                    creative_name,
                    creative_slot,
                    index,
                    button_name,
                    position: this.position,
                  },
                });
              });
          }
          // 如果 button_name2 存在，则添加 button_name2 的点击事件
          if (
            button_name2 &&
            swiper_slide.querySelector('[data-ga4-banner-btn2]')
          ) {
            swiper_slide
              .querySelector('[data-ga4-banner-btn2]')
              .addEventListener('click', () => {
                Shopify.analytics.publish('ga4Event', {
                  log_name: 'swiper banner第二个按钮 点击',
                  event_name: 'click_banner',
                  event_parameters: {
                    promotion_id: creative_id,
                    promotion_name: creative_name,
                    button_name: button_name2,
                    creative_name,
                    creative_slot,
                    index,
                    position: this.position,
                  },
                });
              });
          }
        });
      }
    }
    // button Click
    buttonClick() {
      const button = this.shadowRoot.querySelector('slot');
      button.addEventListener('click', () => {
        Shopify.analytics.publish('ga4Event', {
          log_name: this.log_name || 'button 点击:',
          event_name: 'click_button',
          event_parameters: {
            module: this.module,
            button_name: this.button_name,
            item_list_id: this.item_list_id,
            item_list_name: this.item_list_name,
          },
        });
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    init(); // 初始就需要执行的函数
    // 注册自定义元素
    customElements.define('ug-ga4-track', UgGa4Track);

    if (window.UGrequest.page_type === 'index') {
      ga4_home_init();
    }
    if (window.UGrequest.page_type === 'page') {
      ga4_other_page_init();
    }
    if (window.UGrequest.page_type === 'collection') {
      ga4_collection_init();
    }
    if (window.UGrequest.page_type === 'cart') {
      setTimeout(() => {
        ga4_main_cart_data();
      }, 500);
    }

    if (window.UGrequest.page_type === 'product') {
      setTimeout(() => {
        ga4_product_init();
      }, 1000);
    }
    if (window.UGrequest.page_type === 'article') {
      ga4_blogs_init();
    }
  });

  // 用户基础数据
  function ga4_user_data() {
    function detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // 检测平板
      if (
        /iPad|Tablet|PlayBook|Silk/i.test(userAgent) ||
        (/\bAndroid\b/i.test(userAgent) && !/\bMobile\b/i.test(userAgent))
      ) {
        return 'Tablet';
      }

      // 检测手机
      if (
        /Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
      ) {
        return 'Mobile';
      }

      // 默认是 PC
      return 'PC';
    }

    const operating_platform = detectDevice();
    // Example for accessing event data
    const login_status = window.UGrequest?.CUSTOMER_ID ? 'Logged' : 'Logout';
    const user_id = window.UGrequest?.CUSTOMER_ID || ''; // 第一次接受 cookie 的时候，是空的，刷新页面后才会有值
    const country_code = 'NAS UK';
    const content_group = document.title;
    const pathname = window?.location?.pathname;
    return {
      operating_platform,
      login_status,
      user_id,
      pathname,
      country_code,
      content_group,
      page_location,
      item_list_name,
      item_list_id,
    };
  }
  /************************ 通用函数 **************************/
  function findParent(element, className) {
    while (
      element.parentElement &&
      !element.parentElement.classList.contains(className)
    ) {
      element = element.parentElement;
    }
    return element.parentElement;
  }

  function ga4_dealy_report(data) {
    const base_data = ga4_user_data();
    sessionStorage.setItem(
      'ga4_dealy_report',
      JSON.stringify({
        ...data,
        event: 'delayed_ga4Event',
        common_delayed_data: {
          ...base_data,
          page_location,
          page_referrer,
          page_title,
          item_list_id,
          item_list_name,
        },
      })
    );
  }
  function dom_listen_click(dataList) {
    dataList.forEach(function (item) {
      const {
        wrapper_dom,
        dom,
        module,
        position,
        event_name,
        log_name,
        event_parameters = {},
        text_dom,
        button_name,
        except_dom,
        type,
      } = item;
      if (!wrapper_dom) {
        safeAddEventListeners({
          selector: dom,
          callback: (domElements) => {
            domElements.forEach(function (domItem) {
              const final_button_name =
                button_name ||
                domItem.querySelector(text_dom)?.innerText.trim() ||
                domItem.innerText.trim() ||
                domItem.classList[0];
              const finalEventParams = Object.assign({
                button_name: final_button_name,
                ...(position && { position }),
                ...(module && { module }),
                ...event_parameters,
              });
              domItem.addEventListener('click', () => {
                if (event_name === 'video_start') {
                  click_event_data_reporting({
                    event_name,
                    log_name,
                    event_parameters: {
                      ...Object.fromEntries(
                        Object.entries(finalEventParams).filter(
                          ([key]) => key !== 'button_name'
                        )
                      ),
                      video_title: final_button_name,
                    },
                  });
                } else {
                  const delay_reporting =
                    domItem.tagName === 'A' && domItem.target !== '_blank';
                  click_event_data_reporting({
                    event_name,
                    log_name,
                    event_parameters: finalEventParams,
                    delay_reporting,
                  });
                }
              });
            });
          },
        });
      } else {
        // 获取所有wrapper_dom的元素
        safeAddEventListeners({
          selector: wrapper_dom,
          callback: (wrappers) => {
            wrappers.forEach(function (wrapper) {
              // 从各种来源获取按钮名称
              const getButtonName = (domItem) => {
                if (button_name) return button_name;

                const textElement = text_dom && wrapper.querySelector(text_dom);
                if (textElement?.innerText) return textElement.innerText.trim();

                const domElement = domItem;
                if (domElement?.innerText) return domElement.innerText.trim();
                if (domElement?.classList?.[0]) return domElement.classList[0];
                return '';
              };

              // 添加点击事件
              const domItems = wrapper.querySelectorAll(dom);
              if (!domItems?.length) return;
              // 过滤排除的DOM元素
              const filteredDomItems = except_dom
                ? Array.from(domItems).filter(
                    (element) =>
                      !except_dom.some((selector) => element.matches(selector))
                  )
                : domItems;

              filteredDomItems.forEach(function (domItem) {
                const finalButtonName = getButtonName(domItem);

                // 创建事件参数对象
                const finalEventParams = Object.assign({
                  button_name: finalButtonName,
                  ...(position && { position }),
                  ...(module && { module }),
                  ...event_parameters,
                });
                domItem.addEventListener('click', () => {
                  if (event_name === 'video_start') {
                    click_event_data_reporting({
                      event_name,
                      log_name,
                      event_parameters: {
                        ...Object.fromEntries(
                          Object.entries(finalEventParams).filter(
                            ([key]) => key !== 'button_name'
                          )
                        ),
                        video_title: finalButtonName,
                      },
                    });
                  } else {
                    const delay_reporting =
                      domItem.tagName === 'A' && domItem.target !== '_blank';
                    click_event_data_reporting({
                      event_name,
                      log_name,
                      event_parameters: finalEventParams,
                      delay_reporting,
                    });
                  }
                });
              });
            });
          },
        });
      }
    });
  }
  function navigation_listen_click(dataList) {
    dataList.forEach(function (item) {
      // 处理一级菜单
      const wrappers = document.querySelectorAll(item.wrapper_dom) || [];

      wrappers.forEach(function (wrapper) {
        // 获取一级菜单项
        const menuItems = wrapper.querySelectorAll(item.dom) || [];

        // 过滤排除的DOM元素
        const filteredMenuItems = item.except_dom
          ? Array.from(menuItems).filter(
              (element) =>
                !item.except_dom.some((selector) => element.matches(selector))
            )
          : menuItems;

        // 为一级菜单添加点击事件
        filteredMenuItems.forEach(function (menuItem) {
          menuItem.addEventListener('click', function (event) {
            const navigationName =
              item?.navigation?.name ||
              menuItem.innerText?.trim() ||
              menuItem.classList[0];

            // 上报一级菜单点击
            click_event_data_reporting({
              event_name: item.event_name,
              log_name: item.log_name,
              event_parameters: {
                navigation_name: navigationName,
              },
            });
          });

          // 处理二级菜单
          if (item.children) {
            item.children.forEach(function (childItem) {
              // 获取二级菜单项
              const childMenuItems =
                wrapper.querySelectorAll(childItem.dom) || [];

              // 过滤排除的DOM元素
              const filteredChildItems = childItem.except_dom
                ? Array.from(childMenuItems).filter(
                    (element) =>
                      !childItem.except_dom.some((selector) =>
                        element.matches(selector)
                      )
                  )
                : childMenuItems;

              // 为二级菜单添加点击事件
              filteredChildItems.forEach(function (childMenuItem) {
                childMenuItem.addEventListener('click', function (event) {
                  // 获取父级菜单名称
                  const parentName =
                    item?.navigation?.name ||
                    menuItem.innerText?.trim()?.replace(/\s+/g, '') ||
                    menuItem.classList[0];

                  // 获取子菜单名称
                  const childName =
                    childItem?.navigation?.name ||
                    childMenuItem.innerText?.trim()?.replace(/\s+/g, '') ||
                    childMenuItem.classList[0];

                  // 组合父子菜单名称
                  const combinedName = parentName + '_' + childName;

                  // 上报二级菜单点击
                  click_event_data_reporting({
                    event_name: childItem.event_name,
                    log_name: childItem.log_name,
                    position: childItem.position || item.position,
                    module: childItem.module || item.module,
                    event_parameters: {
                      navigation_name: combinedName,
                    },
                  });
                });
              });
            });
          }
        });
      });
    });
  }
  function dom_listen({ dataList }) {
    dataList.forEach(function (item) {
      const dom = document.querySelectorAll(item.dom) || [];
      dom?.forEach(function (domItem) {
        domItem?.addEventListener('click', function (event) {
          // 不传 button_name 就拿按钮内部文案
          const button_name =
            item?.button_name ||
            domItem?.innerText?.trim() ||
            domItem?.classList[0];
          const module = item?.module;
          const position = item?.position;
          const event_parameters = Object.assign(
            { button_name, module },
            position ? { position } : {}
          );
          click_event_data_reporting({
            event_name: item.event_name,
            log_name: item.log_name,
            event_parameters,
          });
        });
      });
    });
  }
  function click_event_data_reporting({
    event_name = 'click_button',
    log_name,
    event_parameters,
    delay_reporting = false,
  }) {
    if (delay_reporting) {
      ga4_dealy_report({
        log_name: log_name,
        event_name: event_name,
        event_parameters: event_parameters,
      });
    } else {
      Shopify.analytics.publish('ga4Event', {
        log_name: log_name,
        event_name: event_name,
        event_parameters: event_parameters,
      });
    }
  }
  function add_to_cart_data_reporting(event_parameters, product_list_data) {
    const value = product_list_data.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
    Shopify.analytics.publish('ga4Event', {
      log_name: '产品加购按钮点击:',
      event_name: 'add_to_cart',
      event_parameters: {
        currency: currency,
        value: value,
        items: product_list_data,
        ...event_parameters,
      },
    });
  }
  // 页面浏览深度
  function ga4_scroll_data() {
    let maxScrollReported = 0;

    window?.addEventListener('scroll', function () {
      // 计算滚动百分比
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      // 判断当前滚动百分比是否达到下一个 25% 的阈值
      if (scrollPercent >= maxScrollReported + 25) {
        // 更新已上报的最大滚动百分比
        maxScrollReported = Math.floor(scrollPercent / 25) * 25;

        // 将滚动百分比的值传递到 dataLayer
        Shopify.analytics.publish('ga4Event', {
          log_name: '页面浏览深度:',
          event_name: 'scroll',
          event_parameters: {
            percent_scrolled: maxScrollReported,
          },
        });
      }
    });
  }

  /**
   * Safely adds event listeners with retry mechanism
   * @param {Object} options - Configuration options
   * @param {string} options.selector - CSS selector for target elements
   * @param {Function} options.callback - Function to call with found elements
   * @param {number} [options.maxRetries=10] - Maximum number of retry attempts
   * @param {number} [options.retryInterval=300] - Interval between retries in ms
   */
  function safeAddEventListeners({
    selector,
    callback,
    maxRetries = 10,
    retryInterval = 300,
  }) {
    let retryCount = 0;

    function tryAddListeners() {
      const elements = document.querySelectorAll(selector);
      if (elements && elements.length > 0) {
        callback(elements);
      } else if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(tryAddListeners, retryInterval);
      }
    }

    // Try immediately first
    tryAddListeners();
  }
}
